<template>
  <div class="fill_remittance">
    <div class="top">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/costApplication' }"
          >已发费用通知的申请</el-breadcrumb-item
        >
        <el-breadcrumb-item>汇款信息填写</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="main">
      <el-form :model="form" :rules="rules" ref="form" class="demo-ruleForm">
        <table border="1" cellspacing="0" cellpadding="0">
          <tr>
            <td>项目编号:</td>
            <td>
              <el-form-item label="">
                <el-input
                  size="mini"
                  v-model="form.productName"
                  placeholder="请输入项目编号"
                  disabled
                ></el-input>
              </el-form-item>
            </td>
            <td rowspan="9">
              <p>
                1.客户在网络上提交的汇款信息作为我中心确认收费的辅助手段，有助于我中心加快确认首付的速度，
                但我们仍需在确认收到汇款后才能进行确认收费的操作 。
              </p>
              <p>
                2.对于已经提交过汇款信息的申请编号，或者我中心已经进行收费确认操作的申请编号，不能再次提交
                汇款信息。客户如果确认以前提交的汇款信息有误，可在备注栏加中心申请受理部门解决。如需对已经提交过汇款信息的申请编号，请编号补交款时，可在备注栏加以详细说明，或通过其他联系方式。
              </p>
              <p>
                3.使用其他客户名申请的申请编号不能提交。当次汇款包含此类申请需交费用的，请在备注栏说明或通
                过其他方式联络我中心受理申请的部门解决。
              </p>
              <p>
                4.客户提交的汇款信息在其中任何一个申请均未进行收费确认操作的情况下可以修改，但是只要我中心
                已对其中一个或多个申请进行了操作，客户将不能修改。客户确认联系我中心受理申请的部门解决。
              </p>
              <p>5.导入汇款信息和填写更多申请编号这两种方式选择其一即可。</p>
            </td>
          </tr>
          <tr>
            <td>委托单位:</td>
            <td>
              <el-form-item label="" prop="clientName">
                <el-input
                  size="mini"
                  v-model="form.clientName"
                  placeholder="请输入委托单位"
                  disabled
                ></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td>缴费单位:</td>
            <td>
              <el-form-item label="">
                <el-input
                  size="mini"
                  v-model="form.payCompany"
                  placeholder="请输入缴费单位"
                  disabled
                ></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td>产品名称:</td>
            <td>
              <el-form-item label="" prop="projectName">
                <el-input
                  size="mini"
                  v-model="form.projectName"
                  placeholder="请输入产品名称"
                  disabled
                ></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td>项目金额:</td>
            <td>
              <el-form-item label="" prop="itemAmount">
                <el-input
                  size="mini"
                  v-model="form.itemAmount"
                  placeholder="请输入项目金额"
                  disabled
                ></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td>收费通知时间:</td>
            <td>
              <el-form-item label="" prop="time">
                <el-input
                  size="mini"
                  v-model="time"
                  placeholder="请输入收费通知时间"
                  disabled
                ></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td>缴费金额:</td>
            <td>
              <el-form-item label="" prop="paymentAmount">
                <el-input
                  size="mini"
                  v-model="form.paymentAmount"
                  placeholder="请输入缴费金额"
                  :disabled="form.nid"
                ></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td>缴费凭证上传:</td>
            <td>
              <el-upload
                class="avatar-uploader"
                action="111"
                :show-file-list="false"
                :http-request="beforeUpload"
                accept=".jpg,.png,.jpeg"
                :disabled="form.nid"
              >
                <el-button size="small">点击上传凭证</el-button>
              </el-upload>
            </td>
          </tr>
          <tr>
            <td>备注:</td>
            <td>
              <el-input
                size="mini"
                type="textarea"
                :rows="1"
                placeholder="请输入备注"
                v-model="form.remark"
                :disabled="form.nid"
              >
              </el-input>
            </td>
          </tr>
        </table>
      </el-form>

      <div class="footer">
        <el-button @click="returnBack">返回</el-button>
        <el-button v-if="!form.nid" type="primary" @click="submitForm('form')"
          >提交</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { formatDate } from "../../filters/filters.js";
import {
  httpRecordDetails,
  httpMyRecordDetails,
  httpRecordSave,
  httpUpload,
} from "../../utils/myexpends";
export default {
  data() {
    return {
      fileList: [
        {
          name: "food.jpeg",
          url: "https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100",
        },
        {
          name: "food2.jpeg",
          url: "https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100",
        },
      ],
      form: {
        nid: false,
        id: this.$route.query.id,
        productName: "",
        clientName: "",
        payCompany: "",
        projectName: "",
        itemAmount: "",
        time: "",
        paymentAmount: "",
        url: "",
        remark: "",
      },
      rules: {
        clientName: [
          { required: true, message: "请输入委托单位", trigger: "blur" },
        ],
        projectName: [
          { required: true, message: "请输入产品名称", trigger: "blur" },
        ],
        itemAmount: [
          { required: true, message: "请输入项目金额", trigger: "blur" },
        ],
        time: [
          { required: true, message: "请输入收费通知时间", trigger: "blur" },
        ],
        paymentAmount: [
          { required: true, message: "请输入缴费金额", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    time() {
      let data = new Date(this.form.time * 1000);
      return formatDate(data, "yyyy-MM-dd hh:mm:ss");
    },
  },
  methods: {
    //返回
    returnBack() {
      this.$router.go(-1);
    },
    //提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            f_id: this.form.id,
            project_number: this.form.productName,
            enterprise_client_name: this.form.clientName,
            pay_company: this.form.payCompany,
            product_name: this.form.projectName,
            project_money: this.form.itemAmount,
            // ctime: this.form.time,
            money: this.form.paymentAmount,
            image: this.form.url,
            remark: this.form.remark,
          };
          this._httpRecordSave(data);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    //文件上传
    beforeUpload(file) {
      let fd = new FormData();
      fd.append("file", file.file); //传文件
      this._httpUpload(fd);
    },
    //文件上传
    _httpUpload(data) {
      httpUpload(data).then((res) => {
        let data = res.data;
        if (data.code == 0) {
          this.form.url = data.data.data.domian_path;
          console.log(this.form.url);
          this.$message.success(data.msg);
        } else {
          this.$message(data.msg);
        }
      });
    },
    //汇款信息回显
    _httpRecordDetails(id) {
      httpRecordDetails(id).then((res) => {
        let data = res.data;
        if (data.code == 0) {
          this.form.productName = data.data.project_number;
          this.form.clientName = data.data.enterprise_client_name;
          this.form.payCompany = data.data.pay_company;
          this.form.projectName = data.data.product_name;
          this.form.itemAmount = data.data.project_money;
          this.form.time = data.data.ctime;
          this.form.paymentAmount = data.data.money;
          this.form.url = data.data.image;
          this.form.remark = data.data.remark;
        } else {
          this.$message(data.msg);
        }
      });
    },
    //我的汇款记录信息回显
    _httpMyRecordDetails(id) {
      httpMyRecordDetails(id).then((res) => {
        let data = res.data;
        if (data.code == 0) {
          this.form.productName = data.data.project_number;
          this.form.clientName = data.data.enterprise_client_name;
          this.form.payCompany = data.data.pay_company;
          this.form.projectName = data.data.product_name;
          this.form.itemAmount = data.data.project_money;
          this.form.time = data.data.ctime;
          this.form.paymentAmount = data.data.money;
          this.form.url = data.data.image;
          this.form.remark = data.data.remark;
        } else {
          this.$message(data.msg);
        }
      });
    },
    //汇款信息提交
    _httpRecordSave(data) {
      httpRecordSave(data).then((res) => {
        let data = res.data;
        if (data.code == 0) {
          this.$message.success(data.msg);
          this.$router.push("/costApplication");
        } else {
          this.$message(data.msg);
        }
      });
    },
  },
  filters: {
    formatDate(time) {
      var data = new Date(time * 1000);
      return formatDate(data, "yyyy-MM-dd hh:mm:ss");
    },
  },
  mounted() {
    if (this.$route.query.id) {
      this._httpRecordDetails(this.$route.query.id);
    }
    if (this.$route.query.nid) {
      this.form.nid = this.$route.query.nid ? true : false;
      this._httpMyRecordDetails(this.$route.query.nid);
    }
  },
};
</script>

<style lang="scss" scoped>
.fill_remittance {
  .top {
    border-bottom: 2px solid #ccc;
    padding-bottom: 10px;
  }
  .main {
    table {
      width: 100%;
      height: 200px;
      margin-top: 20px;
      border: 1px solid #eee;
      tr {
        td {
          height: 70px;
          padding: 0 15px;
          p {
            margin: 20px;
            line-height: 20px;
          }
          /deep/ .el-form-item {
            margin-bottom: 0 !important;
          }
          /deep/ .el-form-item__error {
            padding-top: 0 !important;
          }
        }
        td:first-of-type {
          width: 30%;
        }
        td:nth-of-type(2) {
          width: 30%;
        }
      }
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
}
</style>